"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_web_components_1 = require("@nimles/react-web-components");

var react_redux_1 = require("react-redux");

var react_redux_2 = require("@nimles/react-redux");

exports.AddToCart = function (_a) {
  var product = _a.product;
  var dispatch = react_redux_1.useDispatch();
  var cart = react_redux_1.useSelector(function (_a) {
    var carts = _a.carts;
    return carts.selected;
  });
  var item = cart && cart.items && cart.items.find(function (i) {
    return i.productId === product.id;
  });

  var _b = react_1.useState(item ? item.quantity : 1),
      quantity = _b[0],
      setQuantity = _b[1];

  var _c = react_1.useState(false),
      updating = _c[0],
      setUpdating = _c[1];

  return react_1.default.createElement("form", {
    onSubmit: function onSubmit(e) {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              e.preventDefault();
              setUpdating(true);
              return [4
              /*yield*/
              , dispatch(react_redux_2.updateCartItem(cart.id, {
                productId: product.id,
                quantity: (item ? item.quantity : 0) + quantity
              }))];

            case 1:
              _a.sent();

              setUpdating(false);
              return [2
              /*return*/
              ];
          }
        });
      });
    }
  }, react_1.default.createElement(react_web_components_1.Row, {
    wrap: true
  }, react_1.default.createElement(react_web_components_1.Column, {
    xs: 100,
    sm: 50
  }, react_1.default.createElement(react_web_components_1.Input, {
    align: "right",
    type: "number",
    value: quantity,
    onChange: function onChange(_a) {
      var target = _a.target;
      return setQuantity(+target.value);
    }
  })), react_1.default.createElement(react_web_components_1.Column, {
    xs: 100,
    sm: 50
  }, react_1.default.createElement(react_web_components_1.Button, {
    raised: true,
    primary: true,
    type: "submit"
  }, updating ? 'Adding...' : 'Add to cart'))));
};